import React from 'react';
import styles from './spinner.module.css';

const Spinner = () => {
  return <div className={styles.spinner} role='status' />;
};

export default Spinner;
